export default __webpack_public_path__ + "static/rainforest-alliance-certified-014f6c7b160c855cfe0e54f81861c82f.png";